/*********
 Cart Check
 **********/

// this will check the cart and ensure there is no super protection until final checkout
// mostly for when a user returns from checkout, it keeps protection as an item

window.addEventListener('load', async function () {
    const protectionProduct = cart.items.find(item => item.id === 46922308387130);
    if (protectionProduct) {
        cart = await changeProduct({
            id: protectionProduct.key,
            quantity: 0
        });
        let cartCount = document.querySelector('[count]');
        cartCount.setAttribute('count', cart.item_count);
    }
});


/*********
 Header Sticky
 **********/

// set initial distance from top
let prevScrollPos = 0;
// keep track of visibility
let visible = true;

const header = document.querySelector('#header');

function handleScroll() {

    let atTop = false
// get current distance from top
    const currentScrollPos = window.pageYOffset;

    // Scrolling up
    if (prevScrollPos > currentScrollPos) {
        visible = true;
    } else {
        // Scrolling down
        visible = false;
    }
//reset comparison
    prevScrollPos = currentScrollPos;
    // if we are at the top of the page
    if (prevScrollPos <= 0) {
        atTop = true;
    }

    if (visible && atTop) {
        header.style.transform = 'translateY(0)';
    } else if (visible) {
        // this is calculating the difference of announcement bar at top
        header.style.transform = 'translateY(-34px)';
    } else {
        header.style.transform = 'translateY(-200%)';
    }
}

// header.style.transform = 'translateY(0)';

// window.addEventListener('scroll', handleScroll);


/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// close nav
function closeNav() {
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
    setTimeout(() => {
        document.querySelector("#slider").close();
    }, 600)
}

// close if outside main dialog content
document.querySelector("#slider").addEventListener('click', function (e) {
    if (e.target === this) {
        closeNav();
    }
});

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

//close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});